/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  var screen_xs = 480;
  var screen_sm = 576;
  var screen_md = 768;
  var screen_lg = 992;
  var screen_xl = 1200;

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {

        $('.so-widget-sow-image-grid .sow-image-grid-image').each(function() {
          var $parent = $(this).closest('.sow-image-grid-wrapper');
          $parent.addClass('grid grid-xs-1 grid-sm-2 grid-md-' + $parent.find('.sow-image-grid-image').length);
          $(this).css({
            'background-image': 'url('+ $(this).find('img').attr('src') +')',
          }).addClass('column');
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

        // var updateHomeIntroHeight = function() {
        //   if( $(window).width() > screen_md ) {
        //     $('.home-introduction').height( $(window).height() );
        //   }
        // };
        // updateHomeIntroHeight();

        $(window).resize(function() {
          //updateHomeIntroHeight();
        }).scroll(function() {
          //updateStickHeader();
        });

        $('.home-features .sow-features-list .sow-features-clear').remove();
        $('.home-features .sow-features-list').slick({
          arrows: false,
          dots: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          responsive: [
            {
              breakpoint: screen_sm,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: screen_xs,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },

    'category': {
      init: function() {

        $('.content-posts.masonry-grid').masonry({
          itemSelector: '.grid-item',
          columnWidth: '.grid-sizer'
        });

        
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
